"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amplitude = _interopRequireWildcard(require("@amplitude/analytics-browser"));
var _consent = _interopRequireDefault(require("./consent"));
var _common = require("./common");
var _utils = _interopRequireDefault(require("../../utils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// the amount of time to wait before rechecking if we can initialize
var INITIALIZE_RECHECK_DELAY = 100;
// the amount of times to attempt re-initialization before falling back
// to sending events anonymously
var INITIALIZE_RECHECK_MAX = 20;

// the default things that amplitude should be tracking automatically.
// end consumers can override any of these if they wish
var DEFAULT_AUTOCAPTURE_OPTIONS = {
  attribution: true,
  pageViews: false,
  sessions: false,
  formInteractions: false,
  fileDownloads: false,
  elementInteractions: false
};
var DEFAULT_AMPLITUDE_CONFIG = {
  // this should be eqiuvalent to what we had with the
  // marketing analytics sdk before
  autocapture: DEFAULT_AUTOCAPTURE_OPTIONS,
  transport: 'beacon',
  minIdLength: 1
};
var conditionallyAddKey = function conditionallyAddKey(keyName, value, out) {
  if (value) {
    // the whole point of this method is to populate a single object with props,
    // so passing that object around by reference is the most performant
    // eslint-disable-next-line no-param-reassign
    out[keyName] = value;
  }
};

/**
 * Attempts to read the Amplitude device ID from cookie
 *
 * @param apiToken The Amplitude API token
 * @returns The cookie device ID or undefined if it can't be found
 */
var getDeviceIdFromCookie = function getDeviceIdFromCookie(apiToken) {
  try {
    var amplitudeCookieName = "AMP_".concat(apiToken.substring(0, 10));
    var amplitudeCookie = (0, _utils.default)(amplitudeCookieName);
    var cookieData = JSON.parse(decodeURIComponent(atob(amplitudeCookie)));
    return cookieData === null || cookieData === void 0 ? void 0 : cookieData.deviceId;
  } catch (err) {
    return undefined;
  }
};
var SMAmplitude = exports.default = /*#__PURE__*/function () {
  function SMAmplitude(config) {
    var _this = this;
    _classCallCheck(this, SMAmplitude);
    this.client = void 0;
    this.userProps = {};
    this.config = void 0;
    this.amplitudeSdkInitialized = false;
    this.queuedEvents = [];
    this.recheckCookieAttempts = 0;
    this.config = config;

    // only initialize in a browser
    if (typeof window === 'undefined') {
      return;
    }
    this.initialize();

    // we'll listen in on cookie consent manager's global event for if the consent changes.
    // this way, we don't have to worry about race conditions should this library initialize
    // before cookie consent manager does
    window.addEventListener('FidesUpdated', function () {
      return _this.handleConsentChange();
    });
  }

  /**
   * Initializes the Amplitude SDK
   */
  return _createClass(SMAmplitude, [{
    key: "canSendEvents",
    get:
    /**
     * Returns whether the configuration is valid for sending events
     */
    function get() {
      var _user$session;
      var _this$config = this.config,
        amplitudeToken = _this$config.amplitudeToken,
        user = _this$config.user;
      return (
        // we need an amplitude token...
        !!amplitudeToken &&
        // ...to not be impersonating a user...
        !(user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation)
      );
    }

    /**
     * Whether the use of functional cookies is allowed or not
     */
  }, {
    key: "canUseFunctionalCookies",
    get: function get() {
      return !(0, _consent.default)(this.config.overrideOneTrust || this.config.ignoreCookieConsent);
    }

    /**
     * Returns whether an event should be sent anonymously (i.e. we can't use functional cookies)
     */
  }, {
    key: "shouldSendAnonymously",
    get: function get() {
      return this.config.forceAnonymous || !this.canUseFunctionalCookies && this.recheckCookieAttempts >= INITIALIZE_RECHECK_MAX;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      // if the configuration isn't there, just bail
      if (!this.canSendEvents) {
        return;
      }
      if (!this.amplitudeSdkInitialized && (
      // if functional cookies have been allowed or we've hit the maximum retries waiting
      // for them to become allowed, go ahead and initialize
      this.canUseFunctionalCookies || this.shouldSendAnonymously)) {
        this.client = this.createClient();
        this.hydrateDefaultUserProps();
        this.sendUserProperties();

        // add a bevy of event listeners to detect if the user is leaving the page in
        // some way. this will allow us to flush the event queue and prevent events
        // from being stuck in limbo. why so many events? because different browsers
        // act differently :|
        document.addEventListener('visibilitychange', function () {
          return _this2.flushCache();
        });
        window.addEventListener('pagehide', function () {
          return _this2.flushCache();
        });
        window.addEventListener('beforeunload', function () {
          return _this2.flushCache();
        });

        // flush any events that may have queued before initialization
        this.flushCache();
        this.amplitudeSdkInitialized = true;
      } else if (!this.canUseFunctionalCookies) {
        // retry checking for cookie consent a few times before falling back to sending
        // events anonymously. once the retry max has been reached, initialize will fall back
        // to anonymous mode.
        this.recheckCookieAttempts += 1;
        setTimeout(function () {
          return _this2.initialize();
        }, INITIALIZE_RECHECK_DELAY);
      }
    }

    /**
     * Creates a private Amplitude client instance taking into account the current
     * privacy environment within the browser
     */
  }, {
    key: "createClient",
    value: function createClient() {
      var _this$config2 = this.config,
        amplitudeDeviceId = _this$config2.amplitudeDeviceId,
        amplitudeSessionId = _this$config2.amplitudeSessionId,
        amplitudeToken = _this$config2.amplitudeToken,
        amplitudeAutoCapture = _this$config2.amplitudeAutoCapture,
        user = _this$config2.user,
        forceAnonymous = _this$config2.forceAnonymous;
      var isAuthenticated = user.isAuthenticated,
        userId = user.id,
        group = user.group;
      var config = _objectSpread({}, DEFAULT_AMPLITUDE_CONFIG);
      conditionallyAddKey('deviceId', amplitudeDeviceId, config);
      conditionallyAddKey('sessionId', amplitudeSessionId, config);

      // allow the end consumer to override any of the autocapture options
      if (amplitudeAutoCapture) {
        config.autocapture = _objectSpread(_objectSpread({}, DEFAULT_AUTOCAPTURE_OPTIONS), amplitudeAutoCapture);
      }

      // if functional cookies have been blocked/anonymity is forced, instruct Amplitude to not persist anything\
      config.identityStorage = this.shouldSendAnonymously ? 'none' : 'cookie';

      // if a device ID hasn't been passed explicitly, pull it out of cookies if we can
      // we're not guaranteed that Amplitude will read that value from its own cookie...
      if (!config.deviceId && !forceAnonymous) {
        var savedDeviceId = getDeviceIdFromCookie(amplitudeToken);
        if (savedDeviceId) {
          config.deviceId = savedDeviceId;
        }
      }
      var client = amplitude.createInstance();
      client.init(amplitudeToken, undefined, config);
      if (isAuthenticated) {
        var _group$membership;
        client.setUserId(userId);
        if (group !== null && group !== void 0 && (_group$membership = group.membership) !== null && _group$membership !== void 0 && _group$membership.groupId) {
          var _group$membership2;
          client.setGroup('teamId', group === null || group === void 0 || (_group$membership2 = group.membership) === null || _group$membership2 === void 0 ? void 0 : _group$membership2.groupId);
        }
      }
      return client;
    }

    /**
     * Sends a tracking event to Amplitude
     *
     * @param event The event and properties to send to Amplitude
     */
  }, {
    key: "track",
    value: function track(event) {
      var _this$client;
      var data = event.data;
      var amplitudeEvent = data.amplitudeEvent,
        amplitudeUserProperties = data.amplitudeUserProperties;

      // we don't have enough something. bail
      if (!amplitudeEvent || !this.canSendEvents) {
        return;
      }

      // if amplitude is disabled for any reason, stash the event for later
      // in the event it gets re-enabled so unsent events can get fired
      if (!this.canUseFunctionalCookies && !this.shouldSendAnonymously) {
        this.queuedEvents.push(event);
        return;
      }
      var eventData = (0, _common.prepareEventProperties)(amplitudeEvent, data);

      // if extra user props were in this event, send those along
      if (amplitudeUserProperties) {
        this.sendUserProperties(amplitudeUserProperties);
      }
      (_this$client = this.client) === null || _this$client === void 0 || _this$client.track(amplitudeEvent, _objectSpread({}, eventData));
    }

    /**
     * Pulls out the default user properties that should be sent upon initialization
     *
     * @param user The user configuration from initialization
     */
  }, {
    key: "hydrateDefaultUserProps",
    value: function hydrateDefaultUserProps() {
      var user = this.config.user;

      // start off with noting all the cookie consent values
      var userProps = _objectSpread({}, (0, _common.getCookieConsentUserProperties)());

      // if we're operating in anonymous mode, set that user prop
      if (this.shouldSendAnonymously) {
        userProps.isAnonymized = true;
      } else {
        // tracking the raw user agent string is walled behind cookie acceptance
        // for privacy reasons. even though the request itself is sent with the
        // user-agent header, Amplitude's gonna strip out anything uniquely identifiable
        // when it shoves that into the OS/device model/device family/whatever props
        conditionallyAddKey('userAgent', navigator.userAgent, userProps);

        // in case any previous events were sent anonymously (for whatever reason),
        // flip that bit back to false
        userProps.isAnonymized = false;

        // decorate with additional persistent IDs for DE team
        _common.COOKIES_TO_AMP_PROP.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            cookieName = _ref2[0],
            propertyName = _ref2[1];
          return userProps[propertyName] = (0, _utils.default)(cookieName);
        });
      }

      // decorate logged in user information
      if (user.isAuthenticated) {
        var _user$group, _user$hipaa, _user$hipaa2;
        conditionallyAddKey('languageId', user === null || user === void 0 ? void 0 : user.languageId, userProps);
        conditionallyAddKey('languageName', user === null || user === void 0 ? void 0 : user.languageName, userProps);
        conditionallyAddKey('languageCode', user === null || user === void 0 ? void 0 : user.languageCode, userProps);
        conditionallyAddKey('userPackageId', user === null || user === void 0 ? void 0 : user.package, userProps);
        conditionallyAddKey('userPackageName', (user === null || user === void 0 ? void 0 : user.packageCanonicalName) || (user === null || user === void 0 ? void 0 : user.packageName), userProps);
        conditionallyAddKey('userSubscriptionStatus', user === null || user === void 0 ? void 0 : user.subscriptionStatus, userProps);
        conditionallyAddKey('dateJoined', user === null || user === void 0 ? void 0 : user.joinedAt, userProps);
        conditionallyAddKey('dateSubscribed', user === null || user === void 0 ? void 0 : user.subscribedAt, userProps);
        conditionallyAddKey('userRole', (_user$group = user.group) === null || _user$group === void 0 || (_user$group = _user$group.membership) === null || _user$group === void 0 ? void 0 : _user$group.type, userProps);
        conditionallyAddKey('userDataCenter', user === null || user === void 0 ? void 0 : user.dataCenter, userProps);
        conditionallyAddKey('userCountryCode', this.config.country, userProps);
        conditionallyAddKey('isHipaaAccount', user === null || user === void 0 || (_user$hipaa = user.hipaa) === null || _user$hipaa === void 0 ? void 0 : _user$hipaa.isHipaaEnabled, userProps);
        conditionallyAddKey('isEsdpAccount', user === null || user === void 0 || (_user$hipaa2 = user.hipaa) === null || _user$hipaa2 === void 0 ? void 0 : _user$hipaa2.isSensitiveDataAccount, userProps);
        if (user.email) {
          var _user$email$split = user.email.split('@'),
            _user$email$split2 = _slicedToArray(_user$email$split, 2),
            emailDomain = _user$email$split2[1];
          if (emailDomain && emailDomain.indexOf('.') > -1) {
            userProps.emailDomain = emailDomain;
          }
        }
      }
      this.userProps = userProps;
    }

    /**
     * Sends default user properties on initialization and additional user properties
     * any time via an Amplitude identify event.
     *
     * @param extraUserProps Additional user properties to send with the defaults
     */
  }, {
    key: "sendUserProperties",
    value: function sendUserProperties(extraUserProps) {
      // only send user props on initialization or if there are extra props to be sent
      if (!this.amplitudeSdkInitialized || extraUserProps) {
        var _this$client2;
        var identify = new amplitude.Identify();
        var userProps = _objectSpread(_objectSpread({}, this.userProps), extraUserProps || {});
        Object.keys(userProps).forEach(function (key) {
          identify.set(key, userProps[key]);
        });
        (_this$client2 = this.client) === null || _this$client2 === void 0 || _this$client2.identify(identify);
      }
    }

    /**
     * Event handler for when a user changes cookie consent
     */
  }, {
    key: "handleConsentChange",
    value: function handleConsentChange() {
      // if we are no longer able to use functional cookies and we weren't
      // sending events anonymously before, switch to sending events anonymously
      if (!this.canUseFunctionalCookies && !this.shouldSendAnonymously) {
        this.recheckCookieAttempts = INITIALIZE_RECHECK_MAX;
        this.client = this.createClient();
      }

      // if consent has been granted where it wasn't before, initialize everything and send any queued events
      if (!this.amplitudeSdkInitialized && !this.shouldSendAnonymously) {
        this.initialize();
      }

      // flush any queued events
      this.flushCache();
    }

    /**
     * Sends any queued events and flushes the Amplitude event cache
     */
  }, {
    key: "flushCache",
    value: function flushCache() {
      var _this3 = this;
      if (this.canSendEvents) {
        this.queuedEvents.forEach(function (event) {
          return _this3.track(event);
        });
        this.queuedEvents = [];
        if (!this.shouldSendAnonymously) {
          var _this$client3;
          (_this$client3 = this.client) === null || _this$client3 === void 0 || _this$client3.flush();
        }
      }
    }
  }]);
}();
module.exports = exports.default;
//# sourceMappingURL=index.js.map